import { Params } from '@angular/router';
import { REDIRECT_PAYMENT_QUERY_PARAMS } from '../routing/routing.enums';

/**
 * Find out if there are any redirect payments query params
 */
export function hasRedirectPaymentsQueryParams(queryParams: Params): boolean {
  return Object.values(REDIRECT_PAYMENT_QUERY_PARAMS).some((key) => queryParams.hasOwnProperty(key));
}
